import getConfig from "next/config";
import { useRouter } from "next/router";

// INF-105 / INF-106 — señales nuevas del listado (badges por tier, etiquetas sobre la foto,
// chip Asciende con countdown) y, bajo el mismo flag, el algoritmo de ranking v2 del
// search-service (header X-Ranking: v2 — ver INF-62/INF-63). Solo marca Fincaraíz: en el
// resto de las marcas siempre devuelve false (APP_THEME se inlinea en build, branch muerto).
// Encendido global: env SERP_SIGNALS_V2=true (publicRuntimeConfig, se toma al boot del server
// — alcanza un reload de PM2, sin rebuild). Override por request para probar en producción
// con el flag apagado: ?serp_signals=1 (y ?serp_signals=0 fuerza apagado).

// Resolver puro, usable fuera de React (p. ej. en getInitialProps, para decidir el header
// de ranking). `query` = objeto de query params (router.query o el query de getInitialProps).
export const resolveSerpSignalsV2 = (query?: { serp_signals?: string | string[] }): boolean => {
	if (process.env.APP_THEME !== "fincaraiz") return false;

	const raw = query?.serp_signals;
	const override = Array.isArray(raw) ? raw[0] : raw;
	if (override === "1") return true;
	if (override === "0") return false;

	return getConfig().publicRuntimeConfig.serpSignalsV2 === true;
};

export const useSerpSignalsV2 = (): boolean => {
	const router = useRouter();
	return resolveSerpSignalsV2(router?.query);
};
